<template>
  <section class="home">
    <HomeTitle
      v-if="$isMobile"
      class="home__title"
    />
    <ViewerWrapper
      class="detail__viewer"
      :product="featuredProduct"
    >
      <div class="home__sticky-content">
        <HomeTitle
          v-if="!$isMobile"
          class="home__title"
        />
        <HomeContent
          v-if="!$isMobile"
          class="home__content"
        />
      </div>
      <HomeCollectionList
        v-if="!$isMobile"
        class="home__collection-list"
      />
    </ViewerWrapper>
    <YearBadge v-if="$isMobile" />
    <HomeContent
      v-if="$isMobile"
      class="home__content"
    />
    <HomeList
      :collection="$getCollectionById($route.params.collectionId)"
      class="product__list"
    />
    <HomeCollectionList
      v-if="$isMobile"
      class="home__collection-list"
    />
    <router-view />
  </section>
</template>

<script>

// import DataHelper from '@/mixins/DataHelper.vue';
import HomeTitle from '@/components/layouts/home/HomeTitle.vue';
import HomeContent from '@/components/layouts/home/HomeContent.vue';
import ViewerWrapper from '@/components/viewer/ViewerWrapper.vue';
import HomeList from '@/components/layouts/home/products/HomeList.vue';
import HomeCollectionList from '@/components/layouts/home/collections/HomeCollectionList.vue';
import YearBadge from '@/components/common/badges/YearBadge.vue';

export default {
  name: 'Home',
  components: {
    ViewerWrapper,
    HomeList,
    HomeCollectionList,
    HomeContent,
    HomeTitle,
    YearBadge,
  },
  // mixins: [DataHelper],

  data() {
    return {
      tease: null,
    };
  },

  computed: {
    featuredProduct() {
      return this.getFeaturedProduct();
    },
  },

  methods: {
    getFeaturedProduct() {
      const products = this.$getProductsByCollectionId(this.$route.params.collectionId);
      const featuredList = this.$filterByWave(products, this.$currentWave);
      const priciestProduct = featuredList.reduce((prev, current) => ((prev.value > current.value) ? prev : current));
      return priciestProduct;
    },
  },
};
</script>
<style lang="stylus" scoped>
.home {
  position: relative;
  min-height: 950px;

  +mobile() {
    padding: 35px 20px 5px;
  }

  .home__sticky-content {
    +desktop() {
      position: absolute;
      top: 30px;
      left: 50px;
    }
  }

  .home__collection-list {
    +mobile() {
      position: sticky;
      bottom: 0;
      background: var(--main-color);
      width: 100vw;
      margin: 0 -20px;
      z-index: 200;
    }

    +desktop() {
      position: absolute;
      bottom: 40px;
      left: 50px;
    }
  }

  .detail__viewer {
    +mobile() {
      margin: 15px auto;
    }
    +desktop(){
      position: sticky;
      top: 0;
      left: 0;
      z-index: 10;
      height: 100vh;
    }
  }

  .home__content {
    +mobile() {
      margin-bottom: 50px;
    }
  }

  .product__list {
    margin: 0px -20px;
    +desktop() {
      margin: -100vh 0 0 0; // Compense l'espace réservé par le viewer sticky
    }
  }
}
</style>
